
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.674 4.998a4.334 4.334 0 00-4.334 4.334c0 .454.074.906.216 1.337l-3.515 2.234a5.418 5.418 0 01-7.103-1.137L29.492 7.55a4.284 4.284 0 00.846-2.553 4.334 4.334 0 00-8.668 0c0 .92.296 1.815.845 2.553l-3.446 4.215a5.417 5.417 0 01-7.1 1.137L8.45 10.67c.143-.431.216-.883.217-1.337a4.334 4.334 0 10-4.713 4.317l2.561 15.364c.087.522.539.905 1.068.905h36.84c.529 0 .98-.383 1.067-.905l2.562-15.364a4.334 4.334 0 00-.38-8.651z","fill":"#FFC107"}})])
          )
        }
      }
    